/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { THEME_COLORS } from '../../../../Shared/theme'
import { useTranslation } from 'react-i18next'

const MissedRevenueBreakdownBar = ({ revenuesMissed, totalMissedRevenueUnavailable, totalMissedRevenueSubstituted, formatFn }) => {
    const [t] = useTranslation()
    const total = revenuesMissed + totalMissedRevenueUnavailable + totalMissedRevenueSubstituted

    if (total <= 0) return null

    const pctMissed = (revenuesMissed / total) * 100
    const pctUnavailable = (totalMissedRevenueUnavailable / total) * 100
    const pctSubstituted = (totalMissedRevenueSubstituted / total) * 100

    const fmt = formatFn || (v => v)

    const segments = [
        { pct: pctMissed, color: THEME_COLORS.RED, value: revenuesMissed, label: t('dashboard.missed_revenues.not_acquired_orders', { count: revenuesMissed }) },
        { pct: pctUnavailable, color: '#f2a3a3', value: totalMissedRevenueUnavailable, label: t('dashboard.missed_revenues.removed_items') },
        { pct: pctSubstituted, color: THEME_COLORS.GREEN, value: totalMissedRevenueSubstituted, label: t('dashboard.missed_revenues.revenue_saved') },
    ].filter(s => s.value > 0)

    return (
        <div css={css`
            width: 100%;
            padding: 0 1rem;
        `}>
            <div css={css`
                text-align: center;
                font-size: .7rem;
                font-weight: 600;
                color: rgba(0, 0, 0, .5);
            `}>
                {t('dashboard.missed_revenues.loss_repartition')}
            </div>

            <div css={css`
                display: flex;
                width: 100%;
                height: 18px;
                border-radius: .29rem;
                overflow: hidden;
                background: #0000001a;
            `}>
                {segments.map((segment, i) => (
                    <div
                        key={i}
                        title={`${segment.label} : ${fmt(segment.value)}`}
                        css={css`
                            width: ${segment.pct}%;
                            background-color: ${segment.color};
                            transition: width .1s ease, background-color .1s ease;
                            position: relative;
                            border-right: ${i < segments.length - 1 ? '1px solid white' : 'none'};
                        `}
                    />
                ))}
            </div>

            <div css={css`
                display: flex;
                justify-content: center;
                gap: .75rem;
                flex-wrap: wrap;
            `}>
                {[
                    { color: THEME_COLORS.RED, label: t('dashboard.missed_revenues.not_acquired_orders', { count: revenuesMissed }), value: revenuesMissed },
                    { color: '#f2a3a3', label: t('dashboard.missed_revenues.removed_items'), value: totalMissedRevenueUnavailable },
                    { color: THEME_COLORS.GREEN, label: t('dashboard.missed_revenues.revenue_saved'), value: totalMissedRevenueSubstituted },
                ].filter(s => s.value > 0).map((item, i) => (
                    <div key={i} css={css`
                        display: flex;
                        align-items: center;
                        gap: .2rem;
                        font-size: .7rem;
                        color: rgba(0, 0, 0, .6);
                    `}>
                        <span css={css`
                            display: inline-block;
                            width: 8px;
                            height: 8px;
                            border-radius: 50%;
                            background-color: ${item.color};
                            flex-shrink: 0;
                        `}/>
                        {item.label}
                    </div>
                ))}
            </div>
        </div>
    )
}

export { MissedRevenueBreakdownBar }




